import React, { useState, useEffect } from "react";
import { authServices } from "../../../../_services/Auth/AuthServices";
import { FetchOption } from "../../../../_services/CommnService/OptionService/FetchOption";
import GstScreen from "./GstScreen";
import LoanOfferData from "./LoanOfferData";
import toastr from "toastr";
import ThankYouScreen from "./ThankYouScreen";
import CompleteKYC from "../../../../assets/images/Progress_Bar1.png";
import CompleteKYC2 from "../../../../assets/images/Progress_Bar2.png";
import CompleteKYC3 from "../../../../assets/images/Progress_Bar3.png";
import MultiLanguageTranslation from "../../../Translate/MultiLangTranslate";
import { IoIosClose } from "react-icons/io";
import LoaderWithLogo from "../../../../_components/Loader/LoaderWithLogo";
import styles from "./styles.module.css";
import { MdKeyboardBackspace } from "react-icons/md";

const BankerRegistration = (props) => {
  const [registrationPage, setRegistrationPage] = useState(1);
  const [apiPayload, setApiPayload] = useState("");
  const [verified, setVerified] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [backRandom, setBackRandom] = useState("");
  const pageChange = (value, data = "") => {
    setRegistrationPage(value);
    if (data) {
      console.log(data);
      setApiPayload(data);
      setError("");
      setBackRandom("")
    }
  };
  const setOptionDataToRedux = async () => {
    var apiresponse = await FetchOption.getByMetaType(null);
    if (apiresponse.data.status_code === 200) {
      props.add(apiresponse.data.data);
    } else {
      toastr.error("something went wrong during fetch option data");
    }
  };
  const onSubmit = async (avgTime, from, to, imageLink) => {
    let flag = 0;
    let data = {
      name: apiPayload.name,
      email: apiPayload.email,
      mobile: props.contact_number,
      pan_number: null,
      aadhar_number: null,
      gstin_number: apiPayload.gst,
      user_type: "banker",
      address: apiPayload.address ? apiPayload.address : null,
      state: apiPayload.state ? apiPayload.state : null,
      district: apiPayload.city ? apiPayload.city : null,
      pincode: apiPayload.pincode ? apiPayload.pincode : null,
      pan_image: null,
      aadhar_front_image: null,
      aadhar_back_image: null,
      tat: avgTime,
      roi_from: from,
      roi_to: to,
      multimedia: imageLink,
    };
    console.log(data);
    // let data = {
    //   "name": name,
    //   "email": email,
    //   "mobile": mobile,
    //   "pan_number": pan ? pan : null,
    //   "aadhar_number": (aadhaar && props.yourDetails.aadhar_front_image !== "") ? aadhaar : null,
    //   "gstin_number": gstNo ? gstNo : null,
    //   "user_type": type,
    //   "address": address,
    //   "state": state,
    //   "district": city,
    //   "pincode": pincode,
    //   "pan_image": panImage ? panImage : null,
    //   "aadhar_front_image": aadhaarFrontImage ? aadhaarFrontImage : null,
    //   "aadhar_back_image": null
    // }

    // let obj = Validation(data, rules)
    // setError(obj)
    // Object.keys(obj).map(index => {
    //   if (obj[index] !== "") {
    //     flag = 1;
    //   }
    // });

    if (flag === 0) {
      setLoader(true);
      // setLoader(true)
      //  let result = await authServices.register(data)
      let result = await authServices.registerUpdateKyc(data);
      console.log(data);
      if (
        result !== null &&
        result !== undefined &&
        result.data &&
        typeof result.data.data === "object" &&
        result.data.data.success_status !== "0"
      ) {
        setLoader(false);
        if (result && result.data && result.data.message) {
          toastr.info(result.data.message);
        }
        if (result.data.data.success_status === "1" && result.data.data.token) {
          localStorage.setItem("authToken", result.data.data.token);
          localStorage.setItem(
            "userDashBoardData",
            JSON.stringify(result.data.data)
          );
          localStorage.setItem(
            "notifications",
            JSON.stringify(result.data.data)
          );
          localStorage.setItem(
            "userDashBoardDataplan",
            JSON.stringify(result.data.data.userPlan)
          );

          localStorage.setItem(
            "disbrusementPopup",
            result.data.data.disbursementPopUp
          );
          if (
            result?.data?.data?.role_name &&
            result.data.data?.member?.roles[0].name ===
              result.data.data.role_name
          ) {
            localStorage.setItem("isOtherUser", "isOtherUser");
          }
          localStorage.setItem(
            "aryauserType",
            result.data.data.member.roles[0].id
          );
          localStorage.setItem("isKyc", result.data.data.member.kyc);
          localStorage.setItem("isParent", result.data.data.member.parent_id);
          localStorage.setItem("user_type", result.data.data.user_type);

          localStorage.setItem("rms_expire", result.data.data.rms_expire);
          localStorage.setItem("rms_token", result.data.data.rms_token);
          localStorage.setItem("rms_user", result.data.data.rms_user);

          setOptionDataToRedux();
          props.clearCartCount();
          props.clearCompare();
          props.addCompareParameter(
            result.data.data.member.comparison_parameters
          );
          props.addCartCount(result.data.data.cart);
          setRegistrationPage(3);
          // props.changeFormType(1);
          // props.close();
          // setTimeout(() => {
          //   window.location.reload();
          // }, 2000);
        }
      } else if (result && result.data && result.data.message) {
        setLoader(false);
        setRegistrationPage(1);
        if (result.data.message.split(" ").includes("Email")) {
          let err = {
            email: result.data.message,
          };
          setError(err);
        }
        else {
          toastr.error(result.data.message);
        }
      } else {
        setLoader(false);
      }
      // setLoader(false);
    }
  };

  return (
    <div>
      <LoaderWithLogo isLoading={loader} />
      <div className="poheader">
      {+registrationPage !== 3 &&<MdKeyboardBackspace
          color={"#5c6b25"}
          size="25"
          onClick={() => {
            registrationPage === 1 ?setBackRandom(Math.random):
            setRegistrationPage(1)}}
        ></MdKeyboardBackspace>}
        {registrationPage != 3 && (
          <img
            src={
              registrationPage == 1 && verified
                ? CompleteKYC2
                : registrationPage == 1
                ? CompleteKYC
                : registrationPage == 2
                ? CompleteKYC3
                : ""
            }
            alt=""
          />
        )}
        <a href="javascript:void(0)">
          <div
            className={styles["bankregcrossicon"]}
            onClick={() => {
              if (registrationPage == 3) {
                props.changeFormType(1);
                props.close();
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              } else {
                props.changeFormType(1);
                props.close();
              }
            }}
          >
            ✖
          </div>
        </a>
        
        {registrationPage != 3 && (
          <h4>
            {" "}
            <MultiLanguageTranslation title="Complete Your KYC" />
          </h4>
        )}
      </div>
      {registrationPage == 1 && (
        <GstScreen
          pageChange={pageChange}
          setVerified={setVerified}
          error={error}
          apiPayload={apiPayload}
          backRandom={backRandom}
        />
      )}
      {registrationPage == 2 && <LoanOfferData onSubmit={onSubmit} />}
      {registrationPage == 3 && (
        <ThankYouScreen
          changeFormType={props.changeFormType}
          close={props.close}
        />
      )}
    </div>
  );
};

export default BankerRegistration;
